import { Skeleton } from 'antd-mobile-v5';
import styles from '../index.less';

const LoadingList = () => {
  return (
    <ul className={styles.loadingList}>
      <li>
        <Skeleton animated className={styles.cardSkeleton} />
      </li>
      <li>
        <Skeleton animated className={styles.cardSkeleton} />
      </li>
      <li>
        <Skeleton animated className={styles.cardSkeleton} />
      </li>
      <li>
        <Skeleton animated className={styles.cardSkeleton} />
      </li>
      <li>
        <Skeleton animated className={styles.cardSkeleton} />
      </li>
    </ul>
  );
};
export default LoadingList;
